export const palette = {
    primary: {
        richElectricBlue: '#0090D1',
        cyanProgress: '#00C3EA',
        darkImperialBlue: '#005075',
        columbiaBlue: '#C9D9E8',
    },
    secondary: {
        azure: '#DEF0F7',
        diamond: '#B9E6F6',
    },
    background: {
        white: '#FFFFFF',
        whiteSmoke: '#F2F5F8',
        azureishWhite: '#E4EAF0',
    },
    text: {
        yankeesBlue: '#152935',
        cadet: '#5A6872',
        quickSilver: '#9DA6AD',
        silverSand: '#C1C1C4',
        gainsboro: '#D8D8D9',
        ghostWhite: '#FAFBFD',
    }
};

export const styles = {
    primaryGradient: `linear-gradient(90deg, ${palette.primary.richElectricBlue}, ${palette.primary.cyanProgress})`
}
